import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logger from '../../services/logger';
import style from './style.module.scss';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className={style.errorContainer}>
          <div className={style.errorHeading}>Something went wrong</div>
          <div className={style.errorDesc}>
            We&apos;re sorry, but something unexpected happened.
          </div>

          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details className={style.errorDetails}>
              <summary>Error Details</summary>
              <pre>{this.state.error.toString()}</pre>
              {this.state.errorInfo && (
                <pre>{this.state.errorInfo.componentStack}</pre>
              )}
            </details>
          )}

          <a href="/" className={style.tryAgainButton}>
            Try Again
          </a>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

export default ErrorBoundary;
